export enum CeilingStyle {
  Open = 'open',
  Flat = 'flat',
  RoofLines = 'rooflines',
}
